import script from "./SupplyView.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplyView.vue?vue&type=script&setup=true&lang=js"

import "./SupplyView.vue?vue&type=style&index=0&id=64e1b2c7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e1b2c7"]])

export default __exports__